import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "../lib/constants";

export const usePrice = () =>
  useQuery({
    queryKey: ["blue-price"],
    queryFn: async () => {
      const { data } = await axios.get(`${API}/price`);
      return data;
    },
    refetchInterval: 20000,
    refetchIntervalInBackground: true,
    staleTime: 15000,
    retry: 1,
  });
